module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_check-31d113638c9b7a29d2da81ab35a8a97a.svg";